import {
    AccountFee,
    Auditable,
    QueryParams,
    SortParams,
    AccountPhoneNumber,
    AccountType,
    AccountUnit,
    Office,
    Country,
} from "..";

export interface Account extends Auditable {
    tenantId: number;
    name: string;
    accountTypeId?: number;
    isInternal: boolean;
    isBilling: boolean;
    isInternational: boolean;
    countryId?: number;
    poRequiredToShip: boolean;
    poRequiredToInvoice: boolean;
    prefersSummaryInvoices: boolean;
    qboCustomerId?: string;
    officeId?: number;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    county?: string;
    phone?: string;
    fax?: string;

    billingContact?: string;
    billingEmail?: string;
    billingAddress1?: string;
    billingAddress2?: string;
    billingCity?: string;
    billingState?: string;
    billingZip?: string;
    billingPhone?: string;
    billingFax?: string;

    asnId?: string;
    billingComments?: string;
    notes?: string;

    milesFromOffice?: number;
    timeFromOffice?: number;
    opo?: string;
    hasRefrigeratedMorgue: boolean;
    noShipping: boolean;
    isPcgEyeBank: boolean;
    includeRemnants: boolean;
    timeZone?: string;

    accountType?: AccountType;
    accountUnits?: AccountUnit[];
    accountPhoneNumbers?: AccountPhoneNumber[];
    accountFees?: AccountFee[];
    office?: Office;
    country?: Country;
}

export const DefaultAccountQueryParams: QueryParams = {
    name: "",
};

export const DefaultAccountSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
